import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      searchVal: "",
      list: [],
      total: 0,
      current: 1,
      // 页码
      perPage: 5,
      rangeBefore: 3,
      rangeAfter: 2,
      batchnumber: '',
      currentindex: -1
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.list = [];
              _this.currentindex = -1;
              url = "/pjyy-deepexi-product-center/api/v1/product/drug/drugByProductNameAndBatch";
              data = {
                page: _this.current,
                size: _this.perPage,
                productName: _this.searchVal
                // batchNumber:this.batchnumber
              };
              _context.next = 6;
              return _this.$getHttpClient().post(url, data);
            case 6:
              result = _context.sent;
              _this.list = result.data.data.list;
              _this.total = result.data.data.total;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSearch: function onSearch() {
      this.current = 1;
      this.getList();
    },
    handleChange: function handleChange(val) {
      this.current = val;
      this.getList();
    },
    goDetail: function goDetail(data) {
      if (data == this.currentindex) {
        this.currentindex = -1;
      } else {
        this.currentindex = data;
      }
    },
    goDetail1: function goDetail1(item) {
      var url = "".concat(process.env.VUE_APP_API_SERVER, "/pjyy-deepexi-product-center/api/v1/product/drug/downloadOneDrugPc?batchNumber=").concat(item.batchNumber, "&productId=").concat(item.productId, "&userId=").concat(this.getUserId());
      location.href = url;
    },
    //获取用户ID
    getUserId: function getUserId() {
      var userInfo = accountStorage.getCacheUserInfo();
      if (userInfo) {
        return userInfo.userId;
      }
      return;
    }
  }
};